const NotFound = () => <div>404 Not Found</div>;
 
export default NotFound;
